import { Partner } from '../../../services';
import { isIntegratedPartner } from '../../../services/PartnerService';
import { useGlobalState } from '../../../state/persistence';
import { useGetLegalInsurances } from './index';

export default function useGetIntegratedPartnerIds(): any {
  const { question, appStore } = useGlobalState();
  const insurances = useGetLegalInsurances();

  const integratedPartnerIds = [];
  let legalInsurancePartnerId, partnerId;

  const getPartner = (partners: Partner[], partnerId: string): Partner => {
    return partners.find((partner) => partner.id === partnerId)!;
  };

  if (question.legalInsurance) {
    const insurance = getPartner(insurances, question.legalInsurance);
    if (isIntegratedPartner(insurance)) {
      integratedPartnerIds.push(question.legalInsurance);
      legalInsurancePartnerId = question.legalInsurance;
    }
  }

  if (appStore.partner) {
    integratedPartnerIds.push(appStore.partner.id);
    partnerId = appStore.partner.id;
  }

  return { integratedPartnerIds, legalInsurancePartnerId, partnerId };
}
